"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcomeMessage = void 0;
var OutcomeMessage;
(function (OutcomeMessage) {
    OutcomeMessage["position"] = "position";
    OutcomeMessage["chat_message"] = "chat_message";
    OutcomeMessage["sync_group_pause"] = "sync_group_pause";
    OutcomeMessage["sync_group_play"] = "sync_group_play";
    OutcomeMessage["change_group_volume"] = "change_group_volume";
    OutcomeMessage["get_client_list"] = "get_client_list";
    OutcomeMessage["mute_group"] = "mute_group";
    OutcomeMessage["ping"] = "ping";
    OutcomeMessage["event_to_group"] = "event_to_group";
})(OutcomeMessage = exports.OutcomeMessage || (exports.OutcomeMessage = {}));
//# sourceMappingURL=OutcomeMessage.js.map